<template>
  <div class="custom-select">
    <div class="select-box" @click="toggleDropdown">
      <div class="selected-item">
        <img :src="selectedIcon" class="icon" />
        <span class="label">{{ selectedLabel }}</span>
        <span class="arrow">&#9660;</span>
      </div>
      <div v-if="isOpen" class="options">
        <div
          v-for="option in options"
          :key="optionKey(option)"
          class="option"
          @click="selectOption(option)"
        >
          <img :src="option.icon" class="icon" />
          <span class="label">{{ optionLabel(option) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Select",
  props: {
    options: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: [String, Number],
      required: true,
    },
    keyField: {
      type: String,
      default: "",
    },
    valueField: {
      type: String,
      default: "",
    },
    labelField: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    selected() {
      return this.modelValue;
    },
    selectedOption() {
      return this.options.find((option) => this.optionValue(option) === this.selected);
    },
    selectedIcon() {
      return this.selectedOption ? this.selectedOption.icon : "";
    },
    selectedLabel() {
      return this.selectedOption ? this.optionLabel(this.selectedOption) : "";
    },
  },
  methods: {
    optionKey(option) {
      return this.keyField ? option[this.keyField] : option;
    },
    optionValue(option) {
      return this.valueField ? option[this.valueField] : option;
    },
    optionLabel(option) {
      return this.labelField ? option[this.labelField] : option;
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.$emit("update:modelValue", this.optionValue(option));
      this.isOpen = false;
    },
  },
};
</script>

<style scoped>
.custom-select {
  position: relative;
  display: inline-block;
  width: 120px;
}

.select-box {
  border: 1px solid #d6d6d6;
  border-radius: 6px;
  padding: 10px 14px;
  cursor: pointer;
  font-weight: 600;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.select-box .selected-item {
  display: flex;
  align-items: center;
}

.select-box .icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.select-box .arrow {
  font-size: 14px;
}

.options {
  position: absolute;
  width: 100%;
  border: 1px solid #d6d6d6;
  border-radius: 6px;
  background: white;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  top: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
}

.option {
  padding: 10px 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.option:hover {
  background-color: #d6d6d6;
}

.option .icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>
